<template>
  <v-card color="primary" elevation="0">
    <v-form>
      <v-card-text class="pa-0">
        <v-expansion-panel v-model="panel" popout expand>
          <v-expansion-panel-content
            class="primary lighten-1 pl-0 pr-0"
            v-for="product in selectedProducts"
            :key="product.id"
            ripple
          >
            <template v-slot:header>
              <div>
                <h3>{{ product.name }}</h3>
              </div>
            </template>
            <v-card class="primary lighten-1" flat>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex sm5 xs12>
                    <v-combobox
                      v-model="category"
                      :items="categories"
                      item-text="name"
                      label="Category"
                      color="secondary"
                      class="mx-2"
                      :loading="isLoading"
                      cache-items
                      required
                      box
                    ></v-combobox>
                  </v-flex>
                  <v-flex sm5 xs12>
                    <v-combobox
                      v-model="product.reason"
                      :items="reasons"
                      item-text="name"
                      item-value="name"
                      label="Reason"
                      color="secondary"
                      class="mx-2"
                      :loading="isLoading"
                      :return-object="false"
                      required
                      box
                    ></v-combobox>
                  </v-flex>
                  <v-flex sm2 xs12>
                    <v-text-field
                      v-model="product.product_qty"
                      label="Quantity"
                      color="secondary"
                      class="mx-2"
                      type="number"
                      :loading="isLoading"
                      required
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <v-combobox
                      v-model="product.rmaType"
                      color="secondary"
                      class="mx-2"
                      label="RMA Type"
                      :items="rmaTypes"
                      :loading="isLoading"
                      :return-object="false"
                      cache-items
                      required
                      box
                    ></v-combobox>
                  </v-flex>
                  <v-flex md6 xs12>
                    <v-text-field
                      color="secondary"
                      label="Refund Amount"
                      class="mx-2"
                      prepend-inner-icon="attach_money"
                      v-model="product.refundAmount"
                      v-if="product.rmaType === 'Partial Refund'"
                      type="Number"
                      :loading="isLoading"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="mb-3 mt-0 pa-0">
                  <v-flex xs12>
                    <v-checkbox
                      v-model="product.isReturning"
                      label="Customer Returning Product?"
                      color="secondary lighten-2"
                      class="mt-0 pl-3"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-textarea
                      v-model="product.remarks"
                      color="secondary"
                      label="Product Remarks"
                      class="mx-2"
                      autofocus
                      box
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-layout row wrap class="mt-4">
          <v-flex xs12>
            <v-textarea
              v-model="remarks"
              color="secondary"
              label="Additional Remarks"
              class="mx-2"
              box
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :loading="isLoading"
          color="secondary lighten-2"
          flat
          @click="finalizeRma()"
          >Finish</v-btn
        >
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    selectedProducts: Array,
    order: Object,
    customer: Object,
    manualEntry: Boolean
  },

  data() {
    return {
      panel: [true],
      category: null,
      reason: null,
      remarks: null,
      rmaTypes: ["Refund", "Partial Refund", "Replacement"]
    };
  },

  computed: {
    ...mapGetters({
      isLoading: "app/isLoading",
      categories: "rma/getCategories",
      reasons: "rma/getReasons",
      user: "app/getUser"
    })
  },

  methods: {
    ...mapActions({
      getReasons: "rma/getReasons",
      clearReasons: "rma/clearReasons",
      create: "rma/create"
    }),

    async finalizeRma() {
      let isReturning = false;
      const payload = {
        saleOrderID: this.order.id,
        saleOrderName: this.order.name,
        saleOrderDate: this.order.date_order,
        customer: this.customer,
        createdBy: this.user.displayName,
        remarks: this.remarks,
        salesChannel: this.manualEntry
          ? this.order.team_id
          : {
              id: this.order.team_id[0],
              name: this.order.team_id[1]
            },
        products: this.selectedProducts.map(product => {
          const productRefund = parseFloat(product.refundAmount);
          const unitPrice = parseFloat(product.price_unit);
          const quantity = parseInt(product.product_qty);
          let refundAmount = unitPrice * product.product_qty;

          switch (product.rmaType) {
            case "Partial Refund":
              refundAmount = productRefund;
              break;
            case "Replacement":
              refundAmount = 0.00;
              break;
          }
          if (product.isReturning) isReturning = true;

          return {
            id: this.manualEntry ? product.id : product.product_id[0],
            product: this.manualEntry ? product.name : product.product_id[1],
            category: this.category ? this.category.name : "",
            reason: product.reason,
            remarks: product.remarks,
            isReturning: product.isReturning,
            owner: product.owner,
            quantity,
            cost: unitPrice,
            type: product.rmaType,
            refundAmount
          };
        }),
        state: isReturning ? "created" : "received"
      };

      await this.create(payload);
    }
  },

  watch: {
    category(category) {
      this.getReasons([
        {
          field: "id",
          operator: "in",
          value: category.reason_ids
        }
      ]);
    }
  }
};
</script>
